import styled from "styled-components/macro";
import Select from "@material-ui/core/Select";
import { ButtonText, PrimaryButton, ToggleSelect, InputNumber, SecondaryButton, InputSwitch } from "@loanbossinc/component-library";
import { Checkbox, RadioGroup } from "@material-ui/core";

const LB_BLUE = "#005AA9";
const LB_RED = "#B5081D";

export const PaddedWrapper = styled.div`
  && {
    padding: ${props => props.padding || "0 1.5em"};
  }
`;

export const StyledSelectButton = styled(PrimaryButton)`
  width: 121px !important;
  height: 36px !important;
  background-color: #005aa9 !important;
  font-size: 14px !important;
`;

export const StyledPrimaryButton = styled(PrimaryButton)`
  width: 160px !important;
  && {
    background: #005aa9;
    font-size: 13px;
  }
  &&:hover {
    background: #005aa9;
  }
`;

export const Row = styled.div`
  align-items: center;
  background: #ffffff;
  border-bottom: ${props => props.borderBottom || "1px solid #dadce0"};
  border-top: ${props => (props.borderTop ? "1px solid #dadce0" : "none")};
  box-sizing: border-box;
  display: flex;
  min-height: 68px;
  justify-content: ${props => props.justifyContent || "space-between"};
  width: 100%;

  &:hover {
    background: ${props => props.background || "#fafafa"};
  }
`;

export const FieldNameWrapper = styled.div`
  && {
    color: #5f6368;
    font-family: Work Sans;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    min-width: 210px;
    text-transform: uppercase;
  }
`;

export const SelectButtonWrapper = styled.div`
  && {
    flex-grow: 1;
    display: flex;
    justify-content: flex-end;
    padding-left: 100px;
    padding-right: 17px;
  }
`;

export const VacancyRateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 2em;
`;

export const VacancyRateHeaderWrapper = styled.div`
  padding: 1em;
  box-sizing: border-box;
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0px 10px 20px rgba(173, 174, 174, 0.25);
  border-top: 1px solid #dadce0;
`;

export const VacancyRateHeaderLeft = styled.div`
  display: flex;
  flex-direction: column;
  align-content: center;
`;

export const VacancyRate = styled.div`
  font-family: Work Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
`;
export const PropertyNameSmall = styled.div`
  font-family: Work Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  color: #5f6368;
`;

export const SelectWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 100%;

  & div {
    margin-top: 0;
  }
`;

export const ParametersRowWrapper = styled.div`
  display: flex;
  align-items: center;
  border-bottom: ${props => (props.border ? props.border : "1px solid #dadce0")};
  padding: ${props => (props.padding ? props.padding : "1em")};
  box-sizing: border-box;
  width: 100%;
`;

export const ParametersRowLeft = styled.div`
  width: 60%;
  font-family: Work Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  display: flex;
`;
export const ParametersRowRight = styled.div`
  display: flex;
  flex-direction: column;
  width: 40%;
  position: relative;
`;

export const StyledInputCheckbox = styled(Checkbox)`
  color: ${props => !props.disabled && "#005aa9 !important"};
`;

export const StyledToggleSelect = styled(ToggleSelect)` && {
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 3px;

  & button {
    width: 150px;
    height: 36px;
    color: #005AA9;
    background: #fff;
    font-size: 14px;
    font-family: Work Sans;
    border: 1px solid #005AA9;
  }

  & button:last-child {
    border-radius: 0px 4px 4px 0px;
  }

  & button:first-child {
    border-radius: 4px 0px 0px 4px;
  }

  .Mui-selected {
    color: #fff;
    background: #005AA9;
    pointer-events: none;
  }
}
`;

export const StyledInputNumber = styled(InputNumber)`
  & div::before {
    border-bottom: ${props => props.isError && "1px solid rgb(255 0 102 / 69%) !important"};
  }

  & div::after {
    border-bottom: ${props => props.isError && "2px solid rgb(255 0 102 / 69%) !important"};
  }
`;

export const Screen2Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  font-family: Work Sans;
  font-style: normal;
  font-weight: normal;
  max-width: ${props => props.maxW};
  padding-bottom: 2em;
`;

export const VacancyHeaderRow = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  box-sizing: border-box;
  padding: 0.5em 1em;
  padding-top: ${props => props.pt};
  border-bottom: ${props => (props.bb ? props.bb : "1px solid #dadce0")};
  font-size: 16px;
`;

export const VacancyTableWrapper = styled.div`
  display: flex;
  margin: 0 1em;
  box-sizing: border-box;
  justify-content: center;
`;

export const VacancyTableLeftWrapper = styled.div`
  display: flex;
  min-width: 490px;
  max-width: 490px;
  flex-direction: column;
  height: fit-content;
`;

export const VacancyTableRightWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: "calc(600px - 2em)";
  overflow-x: auto;
  white-space: nowrap;
  box-sizing: border-box;
  border-right: 1px solid #dadce0;

  &::-webkit-scrollbar {
    background: #dadce0;
    height: 7px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 30px;
    background: #5f6368b5;
  }

  &:hover::-webkit-scrollbar-thumb {
    background: ${LB_BLUE};
  }
`;

export const InfoTableRow = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 60px !important;
  box-sizing: border-box;
  background-color: ${props => props.header && "#fafafa"};
  border-bottom: ${props => props.border || "1px solid #DADCE0"};
  border-top: ${props => props.header && "1px solid #DADCE0"};
  border-left: ${props => props.borderLeft || "1px solid #dadce0"};
  overflow-wrap: break-word;
  overflow: hidden;
`;

export const DataTableRow = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: fit-content;
  height: 60px !important;
  box-sizing: border-box;
  background-color: ${props => props.header && "#fafafa"};
  border-bottom: ${props => props.border};
  border-top: ${props => props.header && "1px solid #DADCE0"};
`;

export const InfoTableCell = styled.div`
  width: ${props => props.w};
  max-width: ${props => props.w};
  text-align: ${props => props.align};
  font-family: Work Sans;
  font-style: normal;
  font-weight: ${props => (props.bold ? "600" : "normal")};
  font-size: 12px;
  line-height: 14px;
  padding: ${props => props.p};
  border-right: ${props => props.borderRight && "1px solid #DADCE0"};
`;

export const DataTableCell = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  box-sizing: border-box;
  width: 91px;
  max-width: 91px;
  font-family: Work Sans;
  font-style: normal;
  font-weight: ${props => (props.bold ? "600" : "normal")};
  font-size: 12px;
  line-height: 14px;
  padding: 0.2em;
`;

export const CellBackgroundWrapper = styled.div`
  width: ${props => props.w};
  height: 100%;
  display: flex;
  box-sizing: border-box;
  align-items: center;
  justify-content: ${props => props.justify};
  border-right: 1px solid #dadce0;
  background: ${props => props.bg || "#FAFAFA"};
`;

export const IncludeLeaseSelect = styled(Select).attrs({ classes: { root: "optionsMenu", list: "optionsList" } })`
   height: ${(props) => props.isMarketRentOnly && props.isOverridden ? "40px" : "27px"} !important;
   width: 120px !important;
   font-size: 12px;
   border: 1px solid ${(props) => props.isOverridden ? LB_RED : LB_BLUE};
   border-radius: 6px;
  
   .optionsMenu {
    font-size: 13px;
    line-height: 1.25em;
    color: #5F6368;
    
    & > div {
      padding: 6px 15px 6px 0;
      text-align: center;
      
      &:hover,
      &:focus,
      &:focus-visible {
        background: none;
      }
    }

    & > div > div {
      white-space: pre-wrap !important;
    }
    
    svg {
       color: currentColor;
     }
   }
   
   &.included {
     background: ${(props) => props.isOverridden ? LB_RED : LB_BLUE};
     
     .optionsMenu {
      color: white;
     }
   }
   
   &:disabled {
     background-color: #cccccc !important;
     color: #00000069 !important;
   }
`;

export const LeaseIncludedButton = styled(SecondaryButton)`
  height: 22px !important;
  width: 120px !important;
  font-size: 12px !important;
  color: ${LB_BLUE} !important;
  border: 1px solid ${LB_BLUE};
  padding: 0 !important;

  &:disabled {
    background-color: #cccccc !important;
    color: #00000069 !important;
  }
`;
export const LeaseExcludedButton = styled(PrimaryButton)`
  height: 22px !important;
  width: 120px !important;
  font-size: 12px !important;
  background-color: ${LB_BLUE} !important;
  padding: 0 !important;

  &:hover {
    background-color: #014d91 !important;
  }

  &:disabled {
    background-color: #cccccc !important;
  }
`;

export const SwitchWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 320px;
  justify-content: space-between;
  & .MuiFormControlLabel-labelPlacementStart {
    margin-left: 0 !important;
  }
`;
export const AnnualizedText = styled.div`
  font-family: Work Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
`;

export const StyledLockedSwitch = styled(InputSwitch)`
  & .Mui-checked {
    color: #2c98f0 !important;
  }
`;

export const ResultPreview = styled.div`
  width: 160px;
  height: 45px;
  background-color: #fafafa;
  border-radius: 8px;
  border: 1px solid #dadce0;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0.3em;
  font-family: Work Sans;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
`;

export const ResultPreviewLabel = styled.div`
  font-family: Work Sans;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 14px;
  color: #5f6368;
  padding-right: 2.2em;
`;

export const InfoCircle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(217.82deg, #f9f9f9 6.94%, rgba(249, 249, 249, 0) 90.56%);
  width: 250px;
  height: 250px;
  border-radius: 50%;

  & img {
    width: 112px;
  }
`;

export const InfoText = styled.div`
  font-family: Work Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #5f6368;
`;

export const LogsContainerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 1em;
  box-sizing: border-box;
`;

export const LogsHeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const LogsContentWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  font-size: 13px;
  font-family: "Work Sans";
  margin-top: 1em;
  padding: 0.5em;
  border-radius: 10px;
  position: relative;
`;

export const LogsContentRow = styled.div`
  display: flex;
  width: 100%;
`;

export const LogsContentLeft = styled.div`
  display: flex;
  min-width: 200px;
`;

export const LogsContentRight = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding-left: 1em;
  font-size: 12px;
`;

export const StyledToolTip = styled.p`
  margin: 0 0 0.3em 0;
  font-family: Work Sans;
  font-size: 12px;
  font-weight: normal;
`;

export const StyledButtonText = styled(ButtonText)`&& {
  width: 10%;
  margin-left: 5px;
  margin-bottom: 5px;
  .label {
    margin-left: 8px;
  } 
  &:hover {
    background: none;
  }
}
`;

export const StyledRadioGroup = styled(RadioGroup)`
  flex-direction: column;
  margin-left: 4em;
`;
